import { createSlice } from '@reduxjs/toolkit'

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        user: {},
        isAuthenticated: false,
    },
    reducers: {
        login: (state, action) => {
            state.user = action.payload
            state.isAuthenticated = true
        },
        logout: (state) => {
            state.user = {}
            state.isAuthenticated = false
        },
        editUser: (state, action) => {
            state.user = action.payload
        }
    },
})

export const { login, logout, editUser } = authSlice.actions
export default authSlice.reducer
